export default __webpack_public_path__ + "static/media/skype.3c7541c0.svg";